import { useRouteError, isRouteErrorResponse } from 'react-router-dom';

export function ErrorPage() {
  const error = useRouteError();

  const renderErrorMessage = () => {
    if (isRouteErrorResponse(error)) {
      return error.statusText;
    } else if (error instanceof Error) {
      return error.message;
    }
    return '';
  }

  return (
    <div className="container mt-5 text-center">
      <h1>Oops!</h1>
      <h3>Something went wrong</h3>
      <p>{renderErrorMessage()}</p>
    </div>
  )
}
